import { useState } from "react";
import { flowSteps } from "@/mocks/crash";
import SectionHeading from "./SectionHeading";

export default function CrashFlow() {
  const [idx, setIdx] = useState(0);
  const current = flowSteps[idx];

  return (
    <section id="flow" className="relative overflow-hidden bg-ink-950 py-16 md:py-24 scroll-mt-16">
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, #E0542E 0, transparent 45%), radial-gradient(circle at 85% 70%, #D9AF59 0, transparent 45%)",
        }}
      ></div>

      <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          light
          eyebrow="CRASH PIPELINE · 崩塌路径"
          title="一场塌房，是如何一步步发生的？"
          desc="没有谁的滤镜是瞬间碎光的。从铸造完美到彻底崩塌，背后往往遵循一套惊人相似的流程。点击任一步骤，看透人设崩塌全过程。"
        />

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {flowSteps.map((s, i) => (
            <button
              key={s.step}
              type="button"
              onClick={() => setIdx(i)}
              className={`group rounded-xl border px-3 py-4 text-left transition-all cursor-pointer ${
                i === idx
                  ? "border-coral-500 bg-coral-500/15"
                  : "border-paper-50/12 bg-paper-50/[0.04] hover:border-paper-50/30"
              }`}
              aria-pressed={i === idx}
            >
              <span
                className={`inline-flex items-center justify-center gap-1 text-xs font-semibold ${
                  i === idx ? "text-coral-400" : "text-paper-50/50"
                }`}
              >
                <i className={s.icon}></i> 第 {i + 1} 阶段
              </span>
              <p
                className={`mt-2 text-sm font-semibold ${
                  i === idx ? "text-paper-50" : "text-paper-50/80"
                }`}
              >
                {s.title}
              </p>
              <span className="mt-1 block text-[10px] tracking-[0.2em] uppercase text-paper-50/40">
                {s.en}
              </span>
            </button>
          ))}
        </div>

        <div className="mt-6 rounded-2xl border border-paper-50/12 bg-paper-50/[0.05] p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="shrink-0 md:w-44 text-center md:text-left">
              <p className="font-display text-6xl text-coral-400">{current.step}</p>
              <p className="mt-2 inline-flex items-center gap-1 text-xs tracking-[0.25em] uppercase text-gold-400">
                <i className={current.icon}></i> {current.en}
              </p>
            </div>
            <div className="h-px md:h-24 md:w-px bg-paper-50/15 hidden md:block"></div>
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-semibold text-paper-50">{current.title}</h3>
              <p className="mt-3 text-paper-50/75 leading-relaxed max-w-2xl">{current.desc}</p>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2 border-t border-paper-50/10 pt-5">
            <span className="text-xs text-paper-50/50 mr-1">完整路径：</span>
            {flowSteps.map((s, i) => (
              <button
                key={s.step}
                type="button"
                onClick={() => setIdx(i)}
                className={`h-1.5 flex-1 min-w-6 rounded-full transition-colors cursor-pointer ${
                  i <= idx ? "bg-coral-500" : "bg-paper-50/15"
                }`}
                aria-label={`跳转到第 ${i + 1} 阶段`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}